import apiClient from "../axios";

const productService = {
  async getVendorProducts(page = 1, perPage = 20, search = "", status = "") {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        per_page: perPage.toString(),
      });

      if (search) params.append("search", search);
      if (status && status !== "all") params.append("status", status);

      const response = await apiClient.get(
        `/vendor/products?${params.toString()}`
      );
      if (response.data && response.data.status === "success") {
        return {
          success: true,
          data: response.data.data,
          meta: response.data.meta || {},
        };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to fetch products",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Failed to fetch products",
      };
    }
  },

  async getProductById(productId, isVendorProduct = false) {
    try {
      const url = isVendorProduct
        ? `/vendor/vendor-product/${productId}`
        : `/vendor/products/${productId}`;
      const response = await apiClient.get(url);
      if (response.data && response.data.status === "success") {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to fetch product",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Failed to fetch product",
      };
    }
  },

  async getAllProducts(page = 1, perPage = 20, search = "", status = "") {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        per_page: perPage.toString(),
      });

      if (search) params.append("search", search);
      if (status && status !== "all") params.append("status", status);

      const response = await apiClient.get(
        `/productslist?${params.toString()}`
      );
      if (response.data && response.data.status === "success") {
        return {
          success: true,
          data: response.data.data,
          meta: response.data.meta || {},
        };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to fetch product",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Failed to fetch product",
      };
    }
  },

  async addProduct(payload) {
    try {
      const response = await apiClient.post("/vendor/products", payload);
      if (response.data && response.data.status === "success") {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to add product",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Failed to add product",
      };
    }
  },

  async updateProduct(productId, payload, userRole, isVendorProduct = false) {
    let url;
    if (userRole === "admin") {
      url = `/admin/products/${productId}`;
    } else if (userRole === "employee") {
      url = `/admin/products/${productId}`;
    } else if (userRole === "vendor") {
      url = `/vendor/vendor-product/${productId}`;
    }
    try {
      const response = await apiClient.put(url, payload);
      if (response.data && response.data.status === "success") {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to update product",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Failed to update product",
      };
    }
  },

  async deleteProduct(productId, userRole) {
    let url;
    if (userRole === "admin") {
      url = `/admin/products/${productId}`;
    } else if (userRole === "employee") {
      url = `/admin/products/${productId}`;
    } else if (userRole === "vendor") {
      url = `/vendor/vendor-product/${productId}`;
    }
    try {
      const response = await apiClient.delete(url);
      if (response.data && response.data.status === "success") {
        return { success: true };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to delete product",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Failed to delete product",
      };
    }
  },

  async getProductsByVendorId(
    vendorId,
    page = 1,
    perPage = 20,
    search = "",
    status = ""
  ) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        per_page: perPage.toString(),
      });

      if (search) params.append("search", search);
      if (status && status !== "all") params.append("status", status);

      const response = await apiClient.get(
        `/admin/vendor/${vendorId}/products?${params.toString()}`
      );
      if (response.data && response.data.status === "success") {
        return {
          success: true,
          data: response.data.data,
          meta: response.data.meta || {},
        };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to fetch vendor products",
        };
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to fetch vendor products",
      };
    }
  },
  async getProductsBulkByVendorId(
    vendorId,
    search = "",
    status = ""
  ) {
    try {
    

      if (search) params.append("search", search);
      if (status && status !== "all") params.append("status", status);

      const response = await apiClient.get(
        `/admin/Bulk/vendor/${vendorId}/products`
      );
      if (response.data && response.data.status === "success") {
        return {
          success: true,
          data: response.data.data,
          meta: response.data.meta || {},
        };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to fetch vendor products",
        };
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to fetch vendor products",
      };
    }
  },
  async updateProductStatus(productId, status, userRole) {
    let url;
    if (userRole === "admin") {
      url = `/admin/products/${productId}/status`;
    } else if (userRole === "employee") {
      url = `/admin/products/${productId}/status`;
    } else {
      throw new Error("Unauthorized");
    }
    try {
      const response = await apiClient.put(url, { status });
      if (response.data && response.data.status === "success") {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to update product status",
        };
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to update product status",
      };
    }
  },

  async updateVendorProduct(vendorProductId, payload, userRole = "vendor") {
    // Always use the new universal endpoint
    try {
      const response = await apiClient.put(
        `/vendor-product/${vendorProductId}`,
        payload
      );
      if (response.data && response.data.status === "success") {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to update vendor product",
        };
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to update vendor product",
      };
    }
  },

  async getVendorProductByVendorProductId(vendorProductId) {
    try {
      const response = await apiClient.get(
        `/vendor-product/${vendorProductId}`
      );
      if (response.data && response.data.status === "success") {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to fetch vendor product",
        };
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to fetch vendor product",
      };
    }
  },

  async deleteVendorProduct(vendorProductId, userRole) {
    let url;
    if (userRole === "admin" || userRole === "employee") {
      url = `/vendor-product/${vendorProductId}`;
    } else if (userRole === "vendor") {
      url = `/vendor/vendor-product/${vendorProductId}`;
    }
    try {
      const response = await apiClient.delete(url);
      if (response.data && response.data.status === "success") {
        return { success: true };
      } else {
        return {
          success: false,
          message: response.data.message || "Failed to delete vendor product",
        };
      }
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to delete vendor product",
      };
    }
  },
};

export default productService;
